/* eslint-disable react/no-array-index-key */

/* eslint-disable react/destructuring-assignment */

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
/**
 *
 * ListFilters
 *
 */
import React from 'react'

import select from '../FormElement/fixture/select.json'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    // margin: `0 ${theme.spacing.unit} 0`,
  },
  stgSelect: {
    padding: `${theme.spacing.unit} 0 0 0`,
    marginTop: '10px',
    '& >div': {
      border: '1px solid #ccc',
      borderRadius: '3px',
    },
    margin: {
      // margin: `0 ${theme.spacing(4)} 0`,
    },
    stgSelect: {
      padding: `${theme.spacing(4)} 0 0 0`,
      marginTop: '10px',
      '& >div': {
        border: '1px solid #ccc',
        borderRadius: '3px',
      },
      '&:before': {
        borderBottom: 'none !important',
      },
      '&:after': {
        background: 'none',
        borderBottom: 'none !important',
      },
      '&:focus': {
        background: 'none',
        borderBottom: 'none !important',
      },
      '&:hover': {
        borderBottom: 'none',
      },
      '& input': {
        padding: '0px',
      },
      '& .MuiSelect-selectMenu* ': {
        width: '90%',
      },
      '& div>div': {
        width: '92%',
        padding: '10px',
      },
    },
    stgLabel: {
      margin: `0  0 ${theme.spacing(4)} 0`,
      transform: 'translate(0, 27.5px) scale(0.75)',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div>div': {
      width: '92%',
      padding: '10px',
    },
  },
  stgLabel: {
    margin: `0  0 ${theme.spacing.unit} 0`,
  },
  mandatory: {
    color: theme.status.errorColor,
  },
})

/* eslint-disable react/prefer-stateless-function */
class SelectWithLabel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filterData: this.props.filterData,
      selected: this.props.selected,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        selected: nextProps.selected,
        filterData: nextProps.filterData,
      })
    }
  }

  handleChange = event => {
    const value = event.target.value.split('#')
    // eslint-disable-next-line react/no-access-state-in-setstate
    const selected = { ...this.state.selected }
    selected[value[0]] = {
      _id: value[1],
      value: event.target.value,
    }
    this.setState({ selected })
    const selectedOption = { ...this.state.selected }
    selectedOption[value[0]] = {
      _id: value[1] === 0 ? '' : value[1],
      value: event.target.value,
    }
    this.props.onChange(selectedOption)
  }

  render() {
    const {
      classes,
      ContainterStyle,
      label,
      value,
      isMandatory,
      onChange,
      isError,
      errorMessage,
      // eslint-disable-next-line no-unused-vars
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      ...rest
    } = this.props
    const { filterData, selected } = this.state
    return (
      <div autoComplete="off" className={classes.root}>
        {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
        {filterData &&
          filterData.map((item, key) => (
            <FormControl
              key={`selectFormControl_${
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                key
              }`}
              fullWidth
              className={classes.margin}
              error={isError}
            >
              {label ? (
                <InputLabel htmlFor={label} className={classes.stgLabel}>
                  {label} {isMandatory && <span className={classes.mandatory}>*</span>}
                </InputLabel>
              ) : (
                ''
              )}
              <Select
                value={
                  // biome-ignore lint/complexity/useOptionalChain: TODO
                  selected && selected[item.key] && selected[item.key].value
                    ? selected[item.key].value
                    : `${item.key}#0`
                }
                onChange={this.handleChange}
                displayEmpty
                name={item.key}
                className={classes.stgSelect}
              >
                <MenuItem value={`${item.key}#0`}>All {item.key}</MenuItem>
                {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
                {item.value &&
                  item.value.map(option => (
                    <MenuItem
                      key={`itemIn${
                        // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                        key
                      }`}
                      value={`${item.key}#${option[`${item.key_prefix}id`]}`}
                    >
                      {option[`${item.key_prefix}name`]}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText id={`${label}-error-text`}>{isError && errorMessage}</FormHelperText>
            </FormControl>
          ))}
      </div>
    )
  }
}

SelectWithLabel.defaultProps = {
  isMandatory: false,
  isError: false,
  errorMessage: 'Invalid value',
  filterData: select,
}

export default withStyles(styles)(SelectWithLabel)
